import React, { useState } from "react";
import Classes from "./styles/style.module.css";
import NotFoundImg from "../../assets/images/common/notFound.png";
import SideNav from "../../assets/containers/sideNav";
import HeaderMobile from "../../assets/containers/headerMobile";
import CustomButton from "../../assets/components/CustomButton";
import { useNavigate } from "react-router-dom";
import BackDrop from "../../assets/containers/backDrop";

const NotFound = (props) => {
  const [openSideBar, setOpenSideBar] = useState(false);
  const navigate = useNavigate();
  const sideBarToggler = () => {
    setOpenSideBar(!openSideBar);
  };
  const fcm = localStorage.getItem("fcm");
  const version = localStorage.getItem("version");
  const homelocation = `/${fcm !== "null" ? `?fcmToken=${fcm}` : ""}${
    version !== "null" ? `&version=${parseFloat(version)}` : ""
  }`;

  return (
    <>
      <SideNav open={openSideBar} sideBarToggler={sideBarToggler} />
      <BackDrop show={openSideBar} toggleMenu={sideBarToggler} />
      <HeaderMobile sideBarToggler={sideBarToggler} fcm={props.fcm} />
      <div className={Classes.notFoundContainer}>
        <div className={Classes.imageContainer}>
          <img src={NotFoundImg} alt="not-found" />
          <p>صفحه مورد نظر پیدا نشد</p>
          <p>لطفا مجدد تلاش کنید</p>
        </div>
        <CustomButton
          text={"بازگشت به صفحه اصلی"}
          color={"primary"}
          clickHandler={() => navigate(homelocation, { replace: true })}
        />
      </div>
    </>
  );
};

export default NotFound;
